import { StateCreator } from 'zustand';

export type AlertState = {
    type: 'danger' | 'success' | 'warning' | 'help' | 'info';
    message: string;
    linkText?: string;
    linkTo?: string;
    duration?: number;
    linkType?: 'button' | 'link';
};

export type AlertSlice = {
    alertData: AlertState;
    isAlertShow: boolean;
    showAlert: (type: AlertState) => void;
    hideAlert: () => void;
};
const initialState: AlertState = {
    type: 'success',
    message: 'Success Alert'
};

export const createConfigurationListSlice: StateCreator<AlertSlice, [], [], AlertSlice> = (set) => ({
    alertData: initialState,
    isAlertShow: false,
    showAlert: (type: AlertState) => {
        set({ alertData: type });
        set({ isAlertShow: true });
    },
    hideAlert: () => {
        set({ isAlertShow: false });
    }
});
